import "./fullscreen-modal.css";

const FullscreenModal = ({
  open,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fs-modal-backdrop">
      <div className="fs-modal">
        <h2>{title}</h2>
        <p>{description}</p>

        <div className="fs-modal-actions">
          <button className="btn cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="btn confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FullscreenModal;
